<section>
    <div class="row mb-3">
        <div class="col-md-12 col-lg-12">
            <div class="d-flex">
                <h4 class="font-weight-bold text-white my-auto">LHND Settings</h4>
            </div>
        </div>
    </div>
    <div class="card">
        <div class="table-responsive">
            <table class="table m-0">
                <thead class="thead">
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <!-- <th>Provider</th>
                        <th>Created On</th> -->
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of lhndData; let i = index">
                        <td>{{i + 1}}</td>
                        <td>{{item?.name}}</td>
                        <!-- <td>{{item?.provider}}</td>
                        <td>{{item?.createdOn}}</td> -->
                        <td>
                            <span><a (click)="navigate(item,'view')" appPermissionButton accessType="write">View</a></span>
                            <!-- <span class="ml-3"><a (click)="navigate(item,'edit')">Edit</a></span> -->
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- <pagination-controls (pageChange)="p = $event" class="text-right"></pagination-controls> -->
    </div>
</section>